export default [
  {
    name: "claimName",
    title: 'Claim Name',
    width: "60%",
    sortField: "claimName",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "fiscalYear",
    title: 'Fiscal Year',
    width: "350px",
    sortField: "fiscalYear",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "fiscalMonth",
    title: 'Fiscal Month',
    width: "350px",
    sortField: "fiscalMonth",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "client",
    title: 'Client',
    width: "10%",
    sortField: "client",
    formatter(value) {
      if (value) {
        return value.name;
      } else {
        return '--';
      }
    }
  },
  {
    name: "analyst",
    title: 'Analyst',
    width: "10%",
    sortField: "analyst",
    formatter(value) {
      if (value) {
        return value.firstName;
      } else {
        return '--';
      }
    }
  },
]